import { useQueryClient } from "@tanstack/react-query";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Button from "@/components/buttons/Button";

import { ROUTES } from "@/config/routes";
import { LOGIN_KEY } from "@/hooks/api/login.hooks";
import { useDestroyProfile } from "@/hooks/api/user.hooks";
import { onError } from "@/utils/onError";

const DeleteProfileModal = ({ closeModal, profileId }: { closeModal: () => void; profileId: number }) => {
  const { t } = useTranslation();
  const { mutate: deleteProfile, isPending } = useDestroyProfile();

  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const handleDelete = () => {
    if (!profileId) return;
    deleteProfile(
      { id: profileId },
      {
        onSuccess: async () => {
          queryClient.invalidateQueries({ queryKey: LOGIN_KEY.profileList });
          closeModal();
          navigate(ROUTES.GATE.PROFILES);
        },
        onError,
      },
    );
  };

  return (
    <div className="max-w-[32.5rem]">
      <div className={"staff-modal__header mb-6"}>
        <h2 className={"staff-modal__title"}>{t("DeleteProfile.title")}</h2>
        <p className={"staff-modal__description"}>{t("DeleteProfile.text")}</p>
      </div>
      <div className="flex flex-row gap-6">
        <Button title={t("Actions.cancel")} color={"black"} onClick={closeModal}>
          {t("Actions.cancel")}
        </Button>
        <Button title={t("Actions.delete")} onClick={handleDelete} isLoading={isPending}>
          {t("Actions.delete")}
        </Button>
      </div>
    </div>
  );
};

export default DeleteProfileModal;
